<out-header
  [logoSrc]="logoSrc"
  [sideLogoSrc]="sideLogoSrc"
  [menuItems]="menuItems"
  [navLinks]="navLinks"
  [isAuthenticated]="isAuthenticated"
>
</out-header>
<div class="content-wrap">
  <router-outlet></router-outlet>
</div>
<out-footer [logoSrc]="footerLogoSrc"></out-footer>
